import React from 'react';
import {PATHS} from '../../Routes';
import {
  BookingSummary,
  ReservationPaymentSummary,
  SUMMARY_PAYMENTS_STATUSES,
} from '@guestapp/sdk';
import incompleteGuestIcon from '../../assets/icons/guest-panel-incomplete-icon.svg';
import completeGuestIcon from '../../assets/icons/guest-panel-complete-icon.svg';
import incompleteDepositIcon from '../../assets/icons/deposit-incomplete.svg';
import completeDepositIcon from '../../assets/icons/deposit-complete.svg';
import incompleteTaxesIcon from '../../assets/icons/taxes-incomplete.svg';
import completeTaxesIcon from '../../assets/icons/taxes-complete.svg';

enum NAVIGATION_STATUSES {
  complete = 'COMPLETE',
  incomplete = 'INCOMPLETE',
}

const PAYMENTS_STATUSES_DISPLAYED_TEXT_DTO: Record<SUMMARY_PAYMENTS_STATUSES, string> = {
  [SUMMARY_PAYMENTS_STATUSES.configurationPending]: 'configuration_pending',
  [SUMMARY_PAYMENTS_STATUSES.readyForPayment]: 'ready_for_payment',
  [SUMMARY_PAYMENTS_STATUSES.payOnArrival]: 'pay_on_arrival',
  [SUMMARY_PAYMENTS_STATUSES.complete]: 'completed',
  [SUMMARY_PAYMENTS_STATUSES.inactive]: 'inactive',
};

const getStatusForPayment = (payment?: ReservationPaymentSummary) => {
  if (!payment?.status) {
    return;
  }

  return PAYMENTS_STATUSES_DISPLAYED_TEXT_DTO[payment?.status];
};

type UseBuildNavigationItemsProps = {data?: BookingSummary};
function useBuildNavigationItems({data}: UseBuildNavigationItemsProps) {
  const navigationItems = React.useMemo(() => {
    return [
      {
        title: 'guest_registration',
        completed: data?.guest_registration?.status === NAVIGATION_STATUSES.complete,
        show: /*data?.guest_registration?.editable*/ true, // PREGUNTAR QUE ONDA PORQUE ALGUNAS RESERVAS SE CREAN CON ESTO EN FALSE
        path: PATHS.guestRegistration,
        icon:
          data?.guest_registration?.status === NAVIGATION_STATUSES.complete
            ? completeGuestIcon
            : incompleteGuestIcon,
      },
      {
        title: 'deposit',
        completed:
          data?.property_protection?.status === SUMMARY_PAYMENTS_STATUSES.complete,
        show: data?.property_protection?.active,
        statusText: getStatusForPayment(data?.property_protection),
        path:
          data?.property_protection?.status === SUMMARY_PAYMENTS_STATUSES.complete
            ? null
            : PATHS.deposits,
        icon:
          data?.property_protection?.status === SUMMARY_PAYMENTS_STATUSES.complete
            ? completeDepositIcon
            : incompleteDepositIcon,
      },
      {
        title: 'tourist_taxes',
        completed: data?.taxes?.status === SUMMARY_PAYMENTS_STATUSES.complete,
        show: data?.taxes?.active,
        statusText: getStatusForPayment(data?.taxes),
        path: PATHS.taxes.main,
        icon:
          data?.taxes?.status === SUMMARY_PAYMENTS_STATUSES.complete
            ? completeTaxesIcon
            : incompleteTaxesIcon,
      },
    ];
  }, [data]);

  const displayedNavigationItems = React.useMemo(() => {
    return navigationItems.filter(navItem => navItem.show);
  }, [navigationItems]);

  return {navigationItems, displayedNavigationItems};
}

export default useBuildNavigationItems;
export {NAVIGATION_STATUSES};
